import { Box } from '@superdispatch/ui-lab';
import { ReactNode } from 'react';
import { viewportHeight } from 'shared/layout/NavigationHeaderBannerHeight';
import styled from 'styled-components';

const Wrapper = styled.div`
  min-height: ${viewportHeight('77px')}; // 77px is the height of the button
`;

export function MobileDrawerFormLayout({
  children,
  action,
}: {
  children: ReactNode;
  action: ReactNode;
}) {
  return (
    <>
      <Wrapper>{children}</Wrapper>

      <Box
        width="100%"
        position="sticky"
        bottom="0"
        padding="small"
        borderTopColor="Silver400"
        borderTopWidth="small"
        backgroundColor="White"
      >
        {action}
      </Box>
    </>
  );
}
